module.exports = __webpack_public_path__ + "img/ef4a95d7256e48f0a807c74e4885ecf4-640.f8dba4ad.png";